<template>
  <v-card outlined>
    <div>
      <v-card-title
        class="subtitle-3 d-flex"
        style="word-break: normal; justify-content: space-evenly; flex-wrap: nowrap"
      >
        <v-btn
          class="text-capitalize"
          depressed
          elevation="8"
          disabled
          fab
          dark
          @click="$emit('prev')"
        >
          <v-icon size="20" v-text="icons.mdiArrowLeft"></v-icon>
        </v-btn>

        <span class="text-h4 pl-5 pr-5">{{ translations.customerReward[lang] }}</span>

        <v-btn
          class="text-capitalize"
          depressed
          :elevation="(canGoToNextStep && !this.loading && 8) || 0"
          dark
          fab
          :disabled="!canGoToNextStep || loading"
          @click="goToNextStep()"
        >
          <v-icon size="20" v-text="icons.mdiArrowRight"></v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text--primary pt-5">
        <v-row class="flex-column justify-center align-center">
          <v-col cols="12" md="12" class="d-flex justify-center pa-5 pb-0">
            <span class="text-center text-subtitle-2 text--secondary">{{
              translations[`customerRewardDescription_${storeMode}`][lang]
            }}</span>
          </v-col>
          <v-card-text class="text--primary pt-5">
            <v-row class="d-flex justify-center transition-all mw-100">
              <v-col
                v-for="(item, index) in rewardTypes"
                :key="index"
                cols="12"
                sm="12"
                md="3"
                class="d-flex flex-column justify-center align-center ma-2 mt-0 pa-12 pt-6 pb-2 select-category transition-all text-subtitle-2 rounded-lg text-center"
                :style="{
                  'min-width': '265px;',
                  'max-width': (rewardTypes.length % 4 == 0 && '150px') || undefined,
                }"
                :class="[
                  rewardTypes.length % 4 == 0 && 'pl-6 pr-6 pt-3 pb-1',
                  selectedRewards.includes(item.system) && 'selected-condition',
                ]"
                @click="attachRewardType(item)"
              >
                <v-sheet
                  class="rounded-lg pa-3 text-center pr-0 pl-0 mw-100 text-subtitle-2 border-grey d-flex justify-center"
                >
                  <v-icon class="ma-5 text-subtitle-1" size="80" v-text="item.icon"></v-icon>
                </v-sheet>
                <div class="pa-3 text-center pr-0 pl-0 mw-100">
                  {{ item.name[lang] }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <div
            ref="conditions"
            id="conditions"
            style="min-height: 200px; max-width: 700px; width: 100%"
          >
            <v-col cols="12" sm="12" md="12" class="d-flex flex-column">
              <v-col
                v-if="selectedRewards.includes('points')"
                cols="12"
                sm="12"
                md="12"
                class="d-flex flex-column"
              >
                <v-row>
                  <v-col cols="12" md="12" class="d-flex justify-center pa-5 pb-0">
                    <span class="text-center text-h5">{{
                      translations[`typeReward_${storeMode}Number`][lang]
                    }}</span>
                  </v-col>

                  <v-col cols="12" md="12" class="d-flex justify-center pa-5 pb-0 pt-2">
                    <span class="text-center text-subtitle-2 text--secondary">{{
                      translations[`reward_${storeMode}Description`][lang]
                    }}</span>
                  </v-col>
                </v-row>

                <v-row class="d-flex justify-center transition-all mw-100">
                  <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="9" class="pr-1 pb-0">
                    <b-text-field
                      v-model="rewardTypes[0].options.points"
                      :label="translations[`reward_${storeMode}`][lang]"
                      type="number"
                      class="pr-1 mt-n1"
                    ></b-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-if="selectedRewards.includes('coupon')"
                cols="12"
                sm="12"
                md="12"
                class="d-flex flex-column"
              >
                <v-row>
                  <v-col cols="12" md="12" class="d-flex justify-center pa-5 pb-0">
                    <span class="text-center text-h5">{{ translations.chooseCoupon[lang] }}</span>
                  </v-col>

                  <v-col cols="12" md="12" class="d-flex justify-center pa-5 pb-0 pt-2">
                    <span class="text-center text-subtitle-2 text--secondary"
                      >{{ translations.chooseCouponRewardDesc[lang] }}.
                      <span class="text-center text-subtitle-2 text--secondary">{{
                        translations.redemptionPeriodDesc[lang]
                      }}</span></span
                    >
                  </v-col>
                </v-row>

                <v-row class="d-flex justify-center transition-all mw-100">
                  <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="9" class="pr-1">
                    <v-autocomplete
                      prepend-inner-icon="mdi-ticket-percent"
                      :items="coupons"
                      v-model="rewardTypes[1].options.gift_ids"
                      item-text="gift_title"
                      item-value="gift_id"
                      menu-props="offsetY"
                      :label="translations.coupon[lang]"
                      class="mt-n1"
                      outlined
                      dense
                      hide-details
                      multiple
                      :search-input.sync="searchCoupons"
                      :loading="loading"
                      :disable-lookup="true"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          v-if="rewardTypes[1].options.gift_ids.length < 5"
                          v-bind="data.attrs"
                          small
                          class="mt-1"
                        >
                          {{ data.item.gift_title }}
                        </v-chip>
                        <div v-else-if="data.index === 0">
                          {{
                            `${rewardTypes[1].options.gift_ids.length} ` +
                            translations.couponsSelected[lang]
                          }}
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="4"
                    lg="4"
                    xl="3"
                    class="pl-1 transition-all"
                    :class="[!rewardTypes[1].options.gift_ids.length && 'invisible mxw0']"
                  >
                    <b-text-field
                      v-model="rewardTypes[1].options.coupon_claim_valid_days"
                      :label="translations.redemptionPeriod[lang]"
                      type="number"
                      class="pr-1 mt-n1"
                    ></b-text-field>
                  </v-col>
                </v-row>
                <div
                  :class="[
                    'transition-all',
                    !rewardTypes[1].options.gift_ids.length && 'invisible',
                  ]"
                >
                  <v-checkbox
                    v-model="couponHasSms"
                    color="secondary"
                    class="mt-1 pt-2 no-messages"
                  >
                    <template v-slot:label>
                      <h4 class="subtitle-2">
                        {{ translations.smsRewardSend[lang] }}
                      </h4>
                    </template>
                  </v-checkbox>
                </div>
                <v-row class="d-flex justify-center transition-all mw-100">
                  <v-col
                    v-if="couponHasSms && rewardTypes[1].options.coupon_notification"
                    cols="12"
                    outlined
                    class="pr-0"
                  >
                    <v-row class="d-flex justify-center transition-all mw-100">
                      <v-col cols="12" outlined class="pr-0">
                        <div
                          class="pa-5 pb-0 pt-2 text-center text-subtitle-2 text--secondary font-weight-light"
                        >
                          <span class="">{{ translations.dynamicRewardSmsDesc1[lang] }}</span>
                          <span class="text--primary font-weight-bold">{voucher}</span>
                          <span class="">{{ translations.dynamicRewardSmsDesc2[lang] }}</span>
                          <span class="text--primary font-weight-bold">{code}</span>
                          <span class="">{{ translations.dynamicRewardSmsDesc3[lang] }}</span>
                          <div
                            class="pa-1 pb-0 text-center text-subtitle-2 text--secondary font-weight-light font-italic"
                          >
                            *<span class="">{{ translations.dynamicRewardSmsVariable[lang] }}</span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <b-textarea
                      v-model="rewardTypes[1].options.coupon_notification[smsLang]"
                      :label="translations.smsRewardContent[lang]"
                      isSms
                    >
                      <template v-slot:append>
                        <b-lang-menu v-model="smsLang" type="inner"></b-lang-menu>
                      </template>
                    </b-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </div>
        </v-row>
      </v-card-text>
    </div>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import {
  mdiArrowLeft,
  mdiLinkVariant,
  mdiMenuRight,
  mdiArrowRight,
  mdiCalendar,
  mdiCalendarMonth,
  mdiMenuUp,
  mdiMenuDown,
  mdiGiftOutline,
  mdiTicketPercentOutline,
  mdiNumeric,
  mdiStore,
  mdiDomain,
  mdiClose,
} from '@mdi/js';
import { mapMutations, mapState, mapActions } from 'vuex';
import translations from '@/utils/translations/loyaltyPanel/campaigns/newReward';
import debounce from 'lodash/debounce';

export default {
  name: 'Step1',

  mixins: [translations],

  data: () => ({
    icons: {
      mdiArrowLeft,
      mdiLinkVariant,
      mdiMenuRight,
      mdiArrowRight,
      mdiCalendar,
      mdiCalendarMonth,
      mdiMenuUp,
      mdiMenuDown,
      mdiNumeric,
      mdiStore,
      mdiDomain,
    },
    searchCoupons: '',
    smsLang: '',
    disableBtn: true,
    couponHasSms: false,
    changeSmsElAuto: true,
    changeSmsItAuto: true,
    changeSmsEnAuto: true,

    rewardTypes: [
      {
        name: {
          en: 'Points',
          el: 'Πόντοι',
          it: 'Punti',
        },
        selected: false,
        icon: mdiGiftOutline,
        system: 'points',
        options: {
          points: null,
          // invoicing_settings: {
          //     company: true,
          //     store: false,
          //     both: false,
          //     both_percentages: {
          //         company: 100
          //     }
          // }
        },
      },
      {
        name: {
          en: 'Coupon',
          el: 'Κουπόνι',
          it: 'Buono',
        },
        selected: false,
        icon: mdiTicketPercentOutline,
        system: 'coupon',
        options: {
          gift_ids: [],
          coupon_notification: {
            en: '',
            el: '',
            it: '',
          },
          coupon_claim_valid_days: null,
        },
      },

      {
        name: {
          en: 'No Reward',
          el: 'Χωρίς Επιβράβευση',
          it: 'Nessuna Ricompensa',
        },
        selected: false,
        icon: mdiClose,
        system: 'no_reward',
        options: { points: 0 },
      },
    ],
    notification: {
      success: false,
      error: '',
    },
  }),

  computed: {
    ...mapState('loyaltyPanel/campaigns/rewards', ['coupons', 'canGoToNextStep', 'step']),

    ...mapState(['loading']),

    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    newReward: {
      get() {
        return this.$store.state.loyaltyPanel.campaigns.rewards.newReward;
      },
      set(val) {
        this.setNewReward(val);
      },
    },

    couponsQuery() {
      if (this.searchCoupons) {
        return `?q=${this.searchCoupons}&page=${this.couponsPage}`;
      }

      return `?page=${this.couponsPage}`;
    },

    selectedRewards() {
      return (this.rewardTypes || []).map((x) => (x.selected ? x.system : '')) || {};
    },

    couponNotification() {
      return this.rewardTypes[1].options.coupon_notification;
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/campaigns/rewards', ['getCoupons']),
    ...mapMutations('loyaltyPanel/campaigns/rewards', ['setCanGoToNextStep', 'setNewReward']),

    checkValue() {
      if (
        this.newReward.gift_ids.length ||
        this.newReward.points ||
        this.selectedRewards.includes('no_reward')
      ) {
        this.disableBtn = false;
      } else {
        this.disableBtn = true;
      }
    },

    attachRewardType(val) {
      // this.selectedRewards.selected = false;
      if (val.system == 'no_reward') {
        this.rewardTypes[0].selected = false;
        this.rewardTypes[1].selected = false;
        this.newReward.points = 0;
        this.newReward.gift_ids = [];
        this.newReward.coupon_claim_valid_days = null;
        this.couponHasSms = false;
        this.newReward.coupon_notification = undefined;
        val.selected = true;
      } else {
        this.rewardTypes[2].selected = false;
        val.selected = !val.selected;
        if (!val.selected) {
          if (val.system == 'points') {
            this.newReward.points = 0;
          } else {
            this.newReward.gift_ids = [];
            this.newReward.coupon_claim_valid_days = null;
            this.couponHasSms = false;
            this.newReward.coupon_notification = undefined;
          }
        } else {
          this.$nextTick(() => {
            this.$vuetify.goTo('#conditions', {
              duration: 300,
              offset: 50,
              easing: 'easeInOutCubic',
            });
          });
        }
      }
    },

    goToNextStep() {
      if (!this.couponHasSms) {
        this.newReward.coupon_notification = undefined;
      } else {
        this.newReward.coupon_notification = this.couponNotification;
      }
      this.$emit('next');
    },

    handleSearchCoupons() {
      const body = {
        query: this.couponsQuery,
        page: this.couponsPage,
      };
      this.getCoupons(body);
    },

    validateStep() {
      let val = this.newReward;
      if (
        this.selectedRewards.includes('no_reward') ||
        (this.selectedRewards.includes('points') &&
          /^\d+$/.test(val.points) &&
          Number(val.points) >= 0) ||
        (this.selectedRewards.includes('coupon') && val.gift_ids?.length)
      ) {
        this.setCanGoToNextStep(true);
      } else {
        this.setCanGoToNextStep(false);
      }
    },
  },

  watch: {
    rewardTypes: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.length) {
          if (val[0].selected) {
            this.newReward.points = this.rewardTypes[0].options.points;
          }
          if (val[1].selected) {
            this.getCoupons();
            this.newReward.gift_ids = this.rewardTypes[1].options.gift_ids;
            this.newReward.coupon_claim_valid_days =
              this.rewardTypes[1].options.coupon_claim_valid_days;
            if (this.couponHasSms) {
              this.newReward.coupon_notification = this.rewardTypes[1].options.coupon_notification;
            }
          } else if (val[2].selected) {
            this.newReward.gift_ids = [];
            this.newReward.coupon_claim_valid_days = null;
          }
        }
      },
    },

    ['newReward']: {
      immediate: true,
      handler(val) {
        this.validateStep();
      },
      deep: true,
    },

    step: {
      immediate: true,
      handler(val) {
        if (val == 1) {
          this.validateStep();
        }
      },
      deep: true,
    },

    searchCoupons() {
      this.couponsPage = 1;
      this.debouncedSearchCoupons();
    },

    ['couponNotification']: {
      handler(val) {
        if (val) {
          let langCapital = this.smsLang[0].toUpperCase() + this.smsLang[1]; //ex. En
          if (this.lang == this.smsLang) {
            if (this.smsLang != 'el' && this.changeSmsElAuto && val.el != val[this.smsLang]) {
              val.el = val[this.smsLang];
            }

            if (this.smsLang != 'it' && this.changeSmsItAuto && val.it != val[this.smsLang]) {
              val.it = val[this.smsLang];
            }

            if (this.smsLang != 'en' && this.changeSmsEnAuto && val.en != val[this.smsLang]) {
              val.en = val[this.smsLang];
            }

            this[`changeSms${langCapital}Auto`] = false;
          } else if (val[this.smsLang] != val[this.lang]) {
            this[`changeSms${langCapital}Auto`] = false;
          }
        }
      },
      deep: true,
    },
    storeMode: {
      immediate: true,
      handler(newMode) {
        let pointsReward = this.rewardTypes.find((reward) => reward.system === 'points');
        if (pointsReward && newMode) {
          if (newMode === 'cashback') {
            pointsReward.name = {
              en: 'Cashback',
              el: 'Επιστροφή Χρημάτων',
              it: 'Rimborso',
            };
          } else {
            pointsReward.name = {
              en: 'Points',
              el: 'Πόντοι',
              it: 'Punti',
            };
          }
        }
      },
    },
  },

  mounted() {
    this.smsLang = this.$route.params.lang;

    if (this.newReward.reward_id) {
      this.rewardTypes[0].options.points = this.newReward.points;
      if (this.newReward.points) {
        this.rewardTypes[0].selected = true;
      }
      if (this.newReward.gift_ids?.length) {
        this.rewardTypes[1].options.gift_ids = this.newReward.gift_ids;
        this.rewardTypes[1].options.coupon_claim_valid_days =
          this.newReward.coupon_claim_valid_days;
        if (this.newReward.coupon_notification) {
          this.couponHasSms = true;
          this.rewardTypes[1].options.coupon_notification = this.newReward.coupon_notification;
        }
        this.rewardTypes[1].selected = true;
      }
      if (!this.newReward.points && !this.newReward.gift_ids?.length) {
        this.rewardTypes[2].selected = true;
      }
    }

    this.validateStep();
  },
  created() {
    this.debouncedSearchCoupons = debounce(this.handleSearchCoupons, 500);
  },
};
</script>

<style scoped>
.border-grey {
  border: 2px solid grey;
}

.b-outlined {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.icon-container {
  /* margin-top:20px; */
  height: 200px;
  width: 200px;
}
.select-category {
  cursor: pointer;
  transition: all 0.5s ease-out;
  background-color: white;
  min-width: 200px;
  font-size: 22px;
  color: gray;
  /* border: 1px solid black */
}
.select-category:hover {
  /* background-color: rgba(0, 0, 0, 0.2); */
  background-color: #27272730;
  color: black;
  border-color: black;
  /* font-size: 26px; */
}

.invisible {
  opacity: 0;
  z-index: 0;
}
.mxw0 {
  max-width: 0px !important;
}

.overlapped {
  position: absolute;
}

.transition-all {
  transition:
    all 1s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 1s;
}
.back-button {
  position: absolute;
  top: 45%;
  z-index: 10;
}
.mw-100 {
  min-width: 100% !important;
}
.mxw-150px {
  max-width: 150px !important;
}
.mw-180 {
  min-width: 180px !important;
}
.selected-condition {
  color: white;
  background: #272727;
  border-color: #272727;
}

.selected-condition .v-icon {
  background: white;
  color: #272727;
}
.selected-condition .border-grey {
  border-color: #272727;
}
.display-none {
  display: none !important;
}
</style>
